import React from 'react';

export const AlignRight = () => (
  <svg width="36" height="36" fill="none" viewBox="0 0 38 38">
    <path
      fill="#116DFF"
      className="illus-clr-1"
      d="M27.5 29.8184L27.5 9.81836L25.5 9.81836L25.5 29.8184L27.5 29.8184Z"
    />
    <path
      fill="#116DFF"
      className="illus-clr-1"
      d="M21.5 20.8184C22.604 20.8184 23.5 21.7144 23.5 22.8184L23.5 25.8184C23.5 26.9224 22.604 27.8184 21.5 27.8184L12.5 27.8184C11.396 27.8184 10.5 26.9224 10.5 25.8184L10.5 22.8184C10.5 21.7144 11.396 20.8184 12.5 20.8184L21.5 20.8184Z"
    />
    <path
      fill="#80B1FF"
      className="illus-clr-2"
      d="M21.5 11.8184C22.604 11.8184 23.5 12.7144 23.5 13.8184L23.5 16.8184C23.5 17.9224 22.604 18.8184 21.5 18.8184L15.5 18.8184C14.396 18.8184 13.5 17.9224 13.5 16.8184L13.5 13.8184C13.5 12.7144 14.396 11.8184 15.5 11.8184L21.5 11.8184Z"
    />
  </svg>
);
